import {Controller} from "@hotwired/stimulus";

// Connects to data-controller="timezone"
export default class extends Controller {
  connect() {
    this.setTimeZone();
  }

  setTimeZone() {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    document.cookie = `timezone=${timezone};path=/`;
  }
}
